module.exports = __webpack_public_path__ + "img/4.c3ca8d8b.png";